import { Component, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import * as AOS from 'aos';
// import { LoginpopupService } from '../loginpopup.service';
// import { HideshowheaderfooterService } from '../hideshowheaderfooter.service';
// import { RestService } from '../rest.service';
import { RestService } from "../../services/rest.service";
import { CustomEventService } from '../../services/custom-event.service';
import { NgForm } from "@angular/forms";

@Component({
  selector: 'app-landing-about-us',
  templateUrl: './landing-about-us.component.html',
  styleUrls: ['./landing-about-us.component.scss']
})
export class LandingAboutUsComponent {
  footerCopyrightYear:any = "2025";
  postbody={"message":"","name":"","mobile":"","email":"","token":"","bs_name":"","bs_address":"","fname":"","lname":""};
  wigetid:any;
  // @ViewChild('recaptcha', {static: false }) recaptchaElement: ElementRef;
  showdloader = false;
  captchablank="1";
  
  constructor(
    public loginpopS: CustomEventService,
    // public hideShow: HideshowheaderfooterService,
    public restProvider: RestService,
    private cdr: ChangeDetectorRef
  ) {
    // this.hideShow.updateHideShowStatus(true);
    // this.hideShow.init();
  }
  ngOnInit(){
    let d1 = new Date();
    this.footerCopyrightYear = d1.getFullYear();
    AOS.init({disable: 'mobile'});//AOS - 2
    AOS.refresh();//refresh method is called on window resize and so on, as it doesn't require to build new store with AOS elements and should be as light as possible.
    const wrapper = document.getElementById("highlight-effect") as HTMLElement;
    const className = "in-view";

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            wrapper.classList.add(className);
            return;
          }

          wrapper.classList.remove(className);
        });
      },
      {
        threshold: 1
      }
    );


    observer.observe(wrapper);
    // this.addRecaptchaScript();
  }
  
  contactsubmit(f1:any,form:any){
    // console.log(f1)
    this.postbody.message = this.postbody.message + ' ' + this.postbody.bs_name + ' '+ this.postbody.bs_address +' '+ '(it is come from landing page)';
    this.postbody.name = this.postbody.fname +' '+ this.postbody.lname;
    // console.log(this.postbody);return;
    if(f1){
    this.showdloader = true;
    this.restProvider
        .postdataapi(this.postbody, "information/contact_us")
        .subscribe((result: any) => {
          console.log(result);
          this.showdloader = false;
          this.loginpopS.opencommonpopup("Sucess",result.status,"normal");
          form.resetForm();
        })
        /* .catch((error: any) => {
          console.log(error);
          this.loginpopS.opencommonpopup("Error",error,"normal");
        });  */
    }

    // this.resetcaptcha();
  }
 /*  resetcaptcha(){
    // console.log(this.wigetid);
    window['grecaptcha'].reset();
    this.postbody.token="";
    this.captchablank="1";
    this.cdr.detectChanges();
  } */

  /* renderReCaptch() {
    this.wigetid=window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey' : '6Ld70-4UAAAAAHO7zINRJL3czFod1Jc6VLT8GNId',
      'callback': (response) => {
          // console.log(response);

          this.postbody.token=response;
         // this.captchablank=false;
          this.captchaerrorreset();
      },
      'expired-callback': (response) =>{

        // console.log(response);
        this.postbody.token="";
        this.captchablank="1";

      },
      'error-callback': (response) =>{

        // console.log(response);
        this.postbody.token="";
        this.captchablank="1";

      }
      
    });
  }
 */
  /* addRecaptchaScript() {
 
    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    }
 
    (function(d, s, id, obj){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
 
  } */

  captchaerrorreset(){

  // console.log("0");
  this.captchablank="0";
  this.cdr.detectChanges();

  // console.log(this.captchablank);
  }
}
